import { create } from './create';
import { deleteNote } from './delete';
import { list } from './list';
import { patch } from './patch';

export const notes = {
  list,
  create,
  patch,
  deleteNote,
};
